/**
 * Mixin bersama untuk halaman master CRUD: state request/loading/message
 * + pagination, dan helper `runRequest`.
 *
 * Komponen pemakai WAJIB mengimplementasikan `fetchList()` (dipakai handler
 * pagination untuk memuat ulang data).
 */
export default {
  data() {
    return {
      activeMethod: '',
      isLoading: false,
      items: [],
      message: {
        text: '',
        variant: 'success',
      },
      pageSizeOptions: [
        { value: 10, text: '10 / page' },
        { value: 25, text: '25 / page' },
        { value: 50, text: '50 / page' },
        { value: 100, text: '100 / page' },
      ],
      pagination: {
        page: 1,
        itemPerPage: 50,
        totalData: 0,
      },
    };
  },
  computed: {
    totalData() {
      return this.pagination.totalData || this.items.length;
    },
  },
  methods: {
    clearMessage() {
      this.message = {
        text: '',
        variant: 'success',
      };
    },
    setMessage(text, variant = 'success') {
      this.message = { text, variant };
    },
    normalizeResponse(data) {
      const rows = Array.isArray(data && data.data) ? data.data : [];
      const pagination = (data && data.pagination) || {};

      this.items = rows;
      this.pagination = {
        page: pagination.page || this.pagination.page,
        itemPerPage: pagination.itemPerPage || this.pagination.itemPerPage,
        totalData: pagination.totalData || rows.length,
      };
    },
    onPageChanged(page) {
      this.pagination.page = page;
      this.fetchList();
    },
    onPageSizeChanged() {
      this.pagination.page = 1;
      this.fetchList();
    },
    async runRequest(method, requestFn, onSuccess, showLoading = true) {
      this.activeMethod = method;
      this.clearMessage();
      this.isLoading = showLoading;

      try {
        const response = await requestFn();

        if (method === 'GET') {
          this.normalizeResponse(response.data);
        }

        if (onSuccess) {
          await onSuccess(response);
        }
      } catch (error) {
        const response = error.response;
        this.setMessage(
          response && response.data && response.data.status && response.data.status.message
            ? response.data.status.message
            : error.message,
          'danger',
        );
      } finally {
        this.isLoading = false;
        this.activeMethod = '';
      }
    },
  },
};
